import { render, staticRenderFns } from "./Ward.vue?vue&type=template&id=71b87d0b&"
import script from "./Ward.vue?vue&type=script&lang=ts&"
export * from "./Ward.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71b87d0b')) {
      api.createRecord('71b87d0b', component.options)
    } else {
      api.reload('71b87d0b', component.options)
    }
    module.hot.accept("./Ward.vue?vue&type=template&id=71b87d0b&", function () {
      api.rerender('71b87d0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/text/sections/Ward.vue"
export default component.exports